import { teeupUserStatusPriorities } from "@config/enums"

export const getPreviewIgnoredStatuses = () => {
  const { invited, backedOut, interested, notInterested } =
    teeupUserStatusPriorities

  return [invited, backedOut, interested, notInterested]
}
